import styled from 'styled-components';
import { TABLET_WIDTH } from 'datastake-daf/src/constants/Style';

const Style = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: var(--size);
  overflow-y: auto;

  @media(${TABLET_WIDTH}) {
    flex-direction: column;
  }

  .apply-cont {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  &.with-gap {
    margin-top: var(--size-lg);
    gap: 12px;

    .inputs-cont {
      display: flex;
      gap: 12px;

      @media(${TABLET_WIDTH}) {
        flex-direction: column;
      }
    }

    .filter-container {
      max-width: 250px;

      @media(${TABLET_WIDTH}) {
        max-width: unset;
      }

      .ant-input, .ant-select-selector {
        border-radius: 6px;
      }
    }
  }

  .filter-container {
    display: flex;
    flex-direction: column;

    .ant-form-item {
      margin-bottom: 0px;
    }
    
    label {
      color: #262626;
      font-weight: 600;
      font-size: 14px;
    }

    .ant-select {
      width: 100%;
    }
  }

  &.filters-wrapper {
    flex-direction: column;
    margin-bottom: 0px;
    
    .filter-container {

      .ant-form-item {
        margin-bottom: var(--size);
      }
    }
  }
`;

export default Style;
